/* Aromante · Menú lateral: logo + cerrar arriba y barra de búsqueda que abre el pop up */
(function () {
  function enhance() {
    const drawer = document.querySelector('header-drawer');
    const panel = drawer && drawer.querySelector('#menu-drawer .menu-drawer__navigation-container');
    if (!panel || panel.querySelector('.aro-drawer__top')) return;
    const summary = drawer.querySelector('details > summary');
    const spInput = document.querySelector('[data-sp-input]');
    const label = (spInput && spInput.placeholder) || 'Buscar perfume o inspiración';

    const top = document.createElement('div');
    top.className = 'aro-drawer__top';
    const logoSrc = document.querySelector('.section-header .header__heading-link');
    if (logoSrc) {
      const logo = logoSrc.cloneNode(true);
      logo.classList.add('aro-drawer__logo');
      logo.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      top.appendChild(logo);
    } else {
      top.appendChild(document.createElement('span'));
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'aro-drawer__close';
    close.setAttribute('aria-label', 'Cerrar menú');
    close.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    close.addEventListener('click', (e) => {
      e.preventDefault();
      if (summary) summary.click();
    });
    top.appendChild(close);

    const search = document.createElement('button');
    search.type = 'button';
    search.className = 'aro-drawer__search';
    search.setAttribute('data-aro-search-open', '');
    search.setAttribute('aria-label', label);
    search.innerHTML = '<span>' + label + '</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 20.5 20.5"/></svg>';

    panel.prepend(search);
    panel.prepend(top);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();

/* Aromante · Red de seguridad del scroll.
   En celular, algunos pop ups bloquean el scroll mientras están abiertos:
   - el carrito lateral (UpCart), con listeners de touch en document;
   - el pop up de Klaviyo, con la clase klaviyo-prevent-body-scrolling en el body.
   A veces el bloqueo no se quita al cerrar y la página deja de hacer scroll aunque los toques sigan funcionando.
   Aquí se registran los bloqueos que se ponen mientras uno de esos pop ups está abierto y, al cerrarlo,
   se quitan los que quedaron. Además, si se toca la página y ya no hay pop up visible, se limpia lo que sobre. */
(function () {
  if (window.__aroScrollGuard) return;
  window.__aroScrollGuard = true;

  const doc = document;
  const KL = 'klaviyo-prevent-body-scrolling';
  const TYPES = { touchstart: 1, touchmove: 1, touchend: 1, touchcancel: 1, wheel: 1 };
  const tracked = [];

  const isCapture = (o) => (typeof o === 'boolean' ? o : !!(o && o.capture));
  const isBlocking = (o) => o && typeof o === 'object' && o.passive === false;
  const cartOpen = () => !!doc.body && doc.body.classList.contains('upcartPopupShow');
  const klLocked = () => !!doc.body && doc.body.classList.contains(KL);
  const lockOpen = () => cartOpen() || klLocked();

  /* ¿Hay un pop up de Klaviyo visible? */
  function klVisible() {
    const els = doc.querySelectorAll('[role="dialog"][class*="kl-private"], [role="dialog"][aria-label$="Form"]');
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      if (!el.getClientRects().length) continue;
      const cs = getComputedStyle(el);
      if (cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity || '1') > 0) return true;
    }
    return false;
  }

  /* Registra los listeners que bloquean el scroll mientras hay un pop up abierto */
  [doc, window].forEach((target) => {
    const origAdd = target.addEventListener;
    const origRemove = target.removeEventListener;
    target.addEventListener = function (type, fn, opts) {
      if (TYPES[type] && fn && isBlocking(opts) && lockOpen()) {
        tracked.push({ target, type, fn, capture: isCapture(opts), remove: origRemove });
      }
      return origAdd.call(this, type, fn, opts);
    };
    target.removeEventListener = function (type, fn, opts) {
      if (TYPES[type]) {
        const cap = isCapture(opts);
        for (let i = tracked.length - 1; i >= 0; i--) {
          const t = tracked[i];
          if (t.target === target && t.type === type && t.fn === fn && t.capture === cap) tracked.splice(i, 1);
        }
      }
      return origRemove.call(this, type, fn, opts);
    };
  });

  function release() {
    if (lockOpen()) return;
    while (tracked.length) {
      const t = tracked.pop();
      t.remove.call(t.target, t.type, t.fn, { capture: t.capture });
    }
    /* estilos que el bloqueo deja en línea */
    [doc.documentElement, doc.body].forEach((el) => {
      if (!el) return;
      if (el.style.overflow === 'hidden') el.style.overflow = '';
      if (el.style.overflowY === 'hidden') el.style.overflowY = '';
      if (el.style.touchAction === 'none') el.style.touchAction = '';
    });
    /* hoja de estilo de overscroll que puede quedar huérfana */
    doc.querySelectorAll('head > style').forEach((s) => {
      const txt = s.textContent || '';
      if (txt.length < 200 && txt.indexOf('@layer') > -1 && txt.indexOf('overscroll-behavior: contain') > -1) s.remove();
    });
    /* El foco puede quedarse en un elemento del pop up que ya no se ve (iPhone deja de hacer scroll hasta tocar otro botón) */
    const a = doc.activeElement;
    if (a && a !== doc.body && a.blur && (!a.isConnected || !a.getClientRects().length)) a.blur();
    /* Recalcular el scroll del body en iPhone */
    if (doc.body) {
      const prev = doc.body.style.overflowY;
      doc.body.style.overflowY = 'auto';
      void doc.body.offsetHeight;
      doc.body.style.overflowY = prev;
    }
  }

  /* Al cerrarse el carrito o el pop up de Klaviyo se limpian los bloqueos sobrantes */
  function watch() {
    new MutationObserver((records) => {
      const was = (re) => records.some((r) => re.test(r.oldValue || ''));
      const cartClosed = was(/(^|\s)upcartPopupShow(\s|$)/) && !cartOpen();
      const klClosed = was(/(^|\s)klaviyo-prevent-body-scrolling(\s|$)/) && !klLocked();
      if (cartClosed || klClosed) setTimeout(release, cartClosed ? 400 : 250);
    }).observe(doc.body, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });

    /* Si se toca la página, Klaviyo sigue bloqueando y ya no hay pop up visible: quitar el bloqueo */
    window.addEventListener('touchstart', () => {
      if (klLocked() && !klVisible()) {
        doc.body.classList.remove(KL);
        release();
      }
    }, { capture: true, passive: true });
  }
  if (doc.body) watch(); else doc.addEventListener('DOMContentLoaded', watch);
})();
